import React from 'react';

import { Alert, Icon } from 'components';
import classNames from 'lib/classNames';

export default function MultiCurrencyModeAlerts ({
	enabled_presentment_currencies,
	draft_checkout_alerted,
	multi_currency_checkout_alerted,
	settings,
	redirectToCheckoutSettings,
	IUnderstand,
}) {
	const showAlerts = enabled_presentment_currencies.length > 1 && !settings.multiCurrencyMode;
	if (!showAlerts) return null;
	return (
		<div>
			{!multi_currency_checkout_alerted && (
				<Alert
					{...{
						type: 'warning',
						borderPosition: 'border-l-4',
						iconSize: '2x',
						title: 'You have multi-currency enabled in your store',
						icon: 'exclamation-circle',
						customStyle: {
							icon: 'text-orange-400 self-start mt-1',
						},
					}}
					className="mt-6 z-5"
				>
					<p>
						Currently customers will only be able to checkout with your default store currency. Visit
						<span
							className={classNames(
								'underline cursor-pointer hover:text-orange-500 focus:outline-none font-semibold mx-1'
							)}
							onClick={redirectToCheckoutSettings}
						>
							Checkout Settings
						</span>
						if you want to enable multi-currency on checkout.
					</p>
					<div className={classNames('flex space-x-3 pt-3 justify-start')}>
						<a
							className={classNames(
								'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
							)}
							href="https://monsterapps.crisp.help/en/article/checkout-settings-multi-currency-discount-codes-draft-checkout-1qsfus8/?1604963115355"
							target="_blank"
						>
							<Icon icon="info-circle" className="mr-2" size="1x" />
							<span className={classNames('text-xs')}>Learn More</span>
						</a>
						<button
							className={classNames(
								'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
							)}
							onClick={redirectToCheckoutSettings}
						>
							<Icon icon="cog" className="mr-2" size="1x" />
							<span className={classNames('text-xs')}>Checkout Settings</span>
						</button>
						<button
							className={classNames(
								'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
							)}
							onClick={() => {
								IUnderstand({
									multi_currency_checkout_alerted: true,
								});
							}}
						>
							<Icon icon="trash-alt" className="mr-2" size="1x" />
							<span className={classNames('text-xs')}>I Understand</span>
						</button>
					</div>
				</Alert>
			)}
			{!draft_checkout_alerted && (
				<Alert
					{...{
						type: 'warning',
						borderPosition: 'border-l-4',
						iconSize: '2x',
						title: 'Draft checkout is currently activated',
						icon: 'exclamation-circle',
						customStyle: {
							icon: 'text-orange-400 self-start mt-1',
						},
					}}
					className="mt-6 z-5"
				>
					<p>This means all store discount codes need to be entered through Upsell Cart. (Not at checkout)</p>
					<p>
						Visit
						<span
							className={classNames(
								'underline cursor-pointer hover:text-orange-500 focus:outline-none font-semibold mx-1'
							)}
							onClick={redirectToCheckoutSettings}
						>
							Checkout Settings
						</span>
						if you want to revert to native Shopify checkout.
					</p>
					<div className={classNames('flex space-x-3 pt-3 justify-start')}>
						<a
							className={classNames(
								'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
							)}
							href="https://monsterapps.crisp.help/en/article/checkout-settings-multi-currency-discount-codes-draft-checkout-1qsfus8/?1604963115355"
							target="_blank"
						>
							<Icon icon="info-circle" className="mr-2" size="1x" />
							<span className={classNames('text-xs')}>Learn More</span>
						</a>
						<button
							className={classNames(
								'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
							)}
							onClick={redirectToCheckoutSettings}
						>
							<Icon icon="cog" className="mr-2" size="1x" />
							<span className={classNames('text-xs')}>Checkout Settings</span>
						</button>
						<button
							className={classNames(
								'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
							)}
							onClick={() => {
								IUnderstand({
									draft_checkout_alerted: true,
								});
							}}
						>
							<Icon icon="trash-alt" className="mr-2" size="1x" />
							<span className={classNames('text-xs')}>I Understand</span>
						</button>
					</div>
				</Alert>
			)}
		</div>
	);
}
